import { ContentSolid } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import { DotIcon } from './icon/DotIcon'
import css from './styles.module.css'

interface Props {
  counter: number
  className: string
}

export const CommentWithContent: React.FC<Props> = ({ counter, className }) => (
  <div className={clsJoin(className, css.comment_content)}>
    {counter}
    <DotIcon className={clsJoin(css.icon_dot, 'comment_content_dot')} />
    <ContentSolid className={clsJoin(css.icon, 'comment_content_icon')} />
  </div>
)
